/* eslint-disable */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Footer component
 *
 * @file Footer.jsx
 * @author Poornima N
 */

import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';

import MojoAppIcon from '../../assets/images/MojoAppIcon';
import {
  FooterContentWrapper,
  FooterContentWrapperVariantB,
  FooterContainer,
  FooterContainerVariantB,
  ListDiv,
  ListDivVariantB,
  FooterList,
  FooterListVariantB,
  ListItemStyled,
  FooterAppLink,
  FooterLink,
  FooterSectionText,
  FooterSectionVariantBText,
  FooterCopyrightSectionText,
  FooterCopyrightSectionVariantBText,
  FooterLinkAppText,
  DownloadAppIcon
} from './FooterStyles';
import CommonUtils from '../../common/utils/CommonUtils';
import * as constants from '../../common/constants';
import Framework from '@greenville/framework';

const Footer = ({
  intl, showAppIcon, menuList, downloadApp
}) => {
  const handleFooterClick = (eventLabel, redirectUrl = '') => {
    const customFields = {
      event_value: eventLabel
    }
    CommonUtils.dispatchGaEvent(constants.FOOTER, constants.FOOTER_EVENT, 'Click Link', eventLabel, customFields) 

    if (redirectUrl) {
      window.open(redirectUrl, '_blank');
    }
  };
  const language = Framework.getStoreRegistry().getStore('language');

  /**
   * Calls handleFooterClick when enter and spacebar key is pressed
   *
   * @param {*} event
   */
  const handleFooterKeyDown = (event, title, url) => {
    const keyCode = event.code;
    switch (keyCode) {
      case constants.ENTERKEY:
        handleFooterClick(title, url);
        break;
      case constants.SPACEKEY:
        handleFooterClick(title, url);
        break;
      default:
        break;
    }
  };

  const ContentWrapper = showAppIcon ? FooterContentWrapper : FooterContentWrapperVariantB;
  const Container = showAppIcon ? FooterContainer : FooterContainerVariantB;
  const ListWrapper = showAppIcon ? ListDiv : ListDivVariantB;
  const NavList = showAppIcon ? FooterList : FooterListVariantB;
  const SectionText = showAppIcon ? FooterSectionText : FooterSectionVariantBText;
  const CopyrightText = showAppIcon ? FooterCopyrightSectionText : FooterCopyrightSectionVariantBText;

  return (
    <React.Fragment>
      <ContentWrapper>
          <Container>
          {showAppIcon &&
              <DownloadAppIcon>
                  <FooterAppLink
                    id="download-app"
                    color="inherit"
                    onClick={() => handleFooterClick('Download the mobile App', downloadApp.url)}
                    onKeyDown={(event) => handleFooterKeyDown(event, 'Download the mobile App', downloadApp.url)}
                    tabIndex="0"
                  >
                    <MojoAppIcon />
                    <FooterLinkAppText
                      component="p"
                      aria-label={language.getMessage('footer.downloadMobileApp')}
                    >
                      <FormattedMessage {...language.getText('footer.downloadMobileApp')} />
                    </FooterLinkAppText>
                  </FooterAppLink>
              </DownloadAppIcon>
            }
            <ListWrapper>
              <NavList>
                {menuList.map(({
                  id, title, url, target, localeString
                }) =>
                (<ListItemStyled key={id} >
                  <FooterLink
                    underline="hover"
                    onClick={() => handleFooterClick(title, url)}
                    onKeyDown={(event) => handleFooterKeyDown(event, title, url)}
                    color="primary"
                    target={target}
                    rel="noopener"
                    aria-label={language.getMessage(title)}
                    tabindex="0"
                  >
                    <SectionText
                      component="p"
                    >
                      {language.getMessage(title)}
                    </SectionText>
                  </FooterLink>
                </ListItemStyled>)
                )}
              </NavList>
            </ListWrapper>
            <CopyrightText
              component="p"
            >
            © 1996–{new Date().getFullYear()} {language.getMessage('footer.copyrights')}
            </CopyrightText>
          </Container>
        </ContentWrapper>
    </React.Fragment>

  );
};


export default injectIntl(Footer);
